import DotNetSplashLayoutLegacy from "./DotNetSplashLayoutLegacy";

const DotNetSplashLegacy = ({id, zoom}: {id: string; zoom: number}) => (
  <DotNetSplashLayoutLegacy id={id} zoom={zoom} scale={1} fallbackTransformId="DotNetSplash" />
);

export default DotNetSplashLegacy;
